export default "__VITE_ASSET__820c5ffc__"